import "@fontsource/open-sans";
import { QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AxiosError } from "axios";
import ReactDOM from "react-dom/client";

import Router from "@/components/Router";
import "@/lib/sentry";
import DataProviders from "@/providers/data";
import LanguageProvider from "@/providers/general/LanguageContext";
import MUIThemeProvider from "@/providers/general/MUIThemeProvider";
import { NotificationProvider } from "@/providers/general/NotificationContext";
import { AuthProvider, removeTokens } from "@/providers/hooks/useAuth";
import { ConfirmProvider } from "@/providers/hooks/useConfirm";
import { PopupProvider } from "@/providers/hooks/usePopup";

import ShiftPopups from "./components/ShiftPopups";
import { SideMenu } from "./layout/SideMenu";
import "./styles/global.scss";
import "./styles/globals.css";
import "./styles/reactQuill.css";

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (err) => {
            const axiosErr = err as AxiosError;
            if (axiosErr && axiosErr.response && axiosErr.response.status === 401) {
                removeTokens();
            }
            return err;
        },
    }),
});

ReactDOM.createRoot(document.getElementById("root")!, {}).render(
    <MUIThemeProvider>
        <QueryClientProvider client={queryClient}>
            <AuthProvider>
                <NotificationProvider>
                    <ConfirmProvider>
                        <PopupProvider>
                            <LanguageProvider>
                                <SideMenu>
                                    <DataProviders>
                                        <>
                                            <Router />
                                            <ShiftPopups />
                                        </>
                                    </DataProviders>
                                </SideMenu>
                            </LanguageProvider>
                        </PopupProvider>
                    </ConfirmProvider>
                </NotificationProvider>
            </AuthProvider>
        </QueryClientProvider>
    </MUIThemeProvider>
);
